import React, { Component } from 'react';
import { Translate } from '../../contexts/Language';
import { BreadCrumb, Card } from '../../components';
import { Config } from '../../config';
import { Service } from '../../services';

export class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        depositManual: false,
        internalTransferManual: false,
      },
    };
  }

  componentDidMount() {
    Config.utilities.loadingFetch();

    Service.User.Settings().then(response => {
      if (response) {
        this.setState({
          formData: response,
        });
      }

      Config.utilities.loadingFetch();
    });
  }

  onSaveSettings() {
    Config.utilities.loadingFetch();

    const { formData } = this.state;

    Service.User.SaveSettings(formData).then(() => {
      Config.utilities.loadingFetch();
    });
  }

  onFormChange(value, key) {
    const { formData } = this.state;

    formData[key] = value;

    this.setState({
      formData,
    });
  }

  render() {
    const { formData } = this.state;

    return (
      <>
        <BreadCrumb Title={Translate('Settings')} Name={Translate('Settings')} />
        <Card Title="Settings" Description="Customer panel settings">
          <div className="form-group row ml-1">
            <label htmlFor="depositManual" className="col-sm-2 col-form-label">Deposit Transfer Manual</label>
            <div className="col-sm-4">
              <input type="checkbox" id="depositManual" name="depositManual" switch="dark" checked={formData.depositManual} onChange={() => this.onFormChange(!formData.depositManual, 'depositManual')} />
              <label htmlFor="depositManual" data-on-label="On" data-off-label="Off" className="mt-2 mb-1" />
            </div>
          </div>
          <div className="form-group row ml-1">
            <label htmlFor="internalTransferManual" className="col-sm-2 col-form-label">Internal Transfer Manual</label>
            <div className="col-sm-4">
              <input type="checkbox" id="internalTransferManual" name="internalTransferManual" switch="dark" checked={formData.internalTransferManual} onChange={() => this.onFormChange(!formData.internalTransferManual, 'internalTransferManual')} />
              <label htmlFor="internalTransferManual" data-on-label="On" data-off-label="Off" className="mt-2 mb-1" />
            </div>
          </div>
          <div className="form-group row ml-1 pt-3">
            <label className="col-sm-2 col-form-label" />
            <div className="col-sm-4">
              <button type="button" className="btn btn-info" onClick={() => this.onSaveSettings()}>
                <i className="far fa-save mr-2" />
                {Translate('Save Settings')}
              </button>
            </div>
          </div>
        </Card>
      </>
    );
  }
}
